import { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import { SettingsHeader } from './components/settings-header';
import { UserTable } from '../../new/components/user-table';
import useUpdateMatter from '@/api/mutations/useUpdateMatter';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useGetUsersInOrg } from '@/api/queries/useGetUsersInOrg';
import { User } from '@/api/types/backend-dto-types';

export function Users() {
  const { matterId } = useParams();
  if (!matterId) return null;

  const { data: matter } = useGetMatterV2(matterId);
  const { data: users } = useGetUsersInOrg();

  const [addedUsers, setAddedUsers] = useState<User[]>([]);

  useEffect(() => {
    if (matter && matter.users) {
      setAddedUsers([...matter.users]);
    }
  }, [matter]);

  const { mutateAsync: updateMatter } = useUpdateMatter(matterId);

  const handleUserChange = async (users: User[]) => {
    setAddedUsers(users);
    try {
      await updateMatter({ userIds: users.map((x) => x.id) });
      toast.success('Users updated');
    } catch (error) {
      toast.error('Failed to update users');
    }
  };

  return (
    <>
      <SettingsHeader
        title="Users"
        subheading={<p className="text-sm text-gray-500">View and manage the users who have access to this matter.</p>}
      />

      <UserTable
        users={users ?? []}
        matterCreatorId={matter?.createdById}
        addedUsers={addedUsers}
        onUserChange={handleUserChange}
      />
    </>
  );
}
